import { useState } from "react";
import { supabase } from "../supabaseClient";

export function useRetakePermissions() {
  const [loadingRetake, setLoadingRetake] = useState(false);

  const grantRetakePermission = async ({
    examSessionId,
    studentUserId,
    reason,
  }) => {
    if (!examSessionId || !studentUserId || !reason) {
      alert("Please select student, exam session, and enter reason.");
      return false;
    }

    setLoadingRetake(true);

    const {
      data: { session },
    } = await supabase.auth.getSession();

    const { error } = await supabase.from("exam_retake_permissions").insert({
      exam_session_id: examSessionId,
      user_id: studentUserId,
      granted_by: session?.user?.id,
      reason,
      status: "active",
    });

    if (error) {
      alert(error.message);
      setLoadingRetake(false);
      return false;
    }

    alert("Retake permission granted.");
    setLoadingRetake(false);
    return true;
  };

  return {
    loadingRetake,
    grantRetakePermission,
  };
}